import { useState, useCallback, useEffect } from 'react'

export type ToastVariant = 'default' | 'destructive' | 'success'

export interface Toast {
  id: string
  title: string
  description?: string
  variant?: ToastVariant
}

interface ToastState {
  toasts: Toast[]
}

let toastState: ToastState = { toasts: [] }
const listeners: Set<() => void> = new Set()

const notify = () => listeners.forEach((listener) => listener())

function addToast(payload: Omit<Toast, 'id'>) {
  const id = Math.random().toString(36).substring(2, 9)
  const newToast: Toast = { id, ...payload, variant: payload.variant ?? 'default' }
  toastState = { toasts: [...toastState.toasts, newToast] }
  notify()
  setTimeout(() => {
    toastState = { toasts: toastState.toasts.filter((t) => t.id !== id) }
    notify()
  }, 5000)
  return { id }
}

export const toast = addToast

export function useToast() {
  const [, setState] = useState(toastState)
  useEffect(() => {
    const listener = () => setState(toastState)
    listeners.add(listener)
    return () => void listeners.delete(listener)
  }, [])

  const dismiss = useCallback((id: string) => {
    toastState = { toasts: toastState.toasts.filter((t) => t.id !== id) }
    notify()
  }, [])

  return { toast: addToast, dismiss, toasts: toastState.toasts }
}
